import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { RmaApiErrorPayload } from '../utils/api-error.util';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly publicPathFragments = [
    '/api/free-tools/',
    '/free-tools/',
    '/api/rent-estimator/',
    '/rent-estimator/',
    '/api/document-types/',
    '/document-types/',
    '/api/countries/',
    '/countries/',
    '/api/states/',
    '/states/',
    '/api/cities/',
    '/cities/'
  ];
  
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get token from localStorage
    const token = localStorage.getItem('rma_token');
    let clonedReq = req;
    
    if (token) {
      clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        const payload = this.asRmaPayload(error.error);
        const shouldLogout =
          error.status === 401 ||
          payload?.code?.trim() === 'RMA-302' ||
          payload?.code?.trim() === 'RMA-303';

        if (
          shouldLogout &&
          !!token &&
          !this.isPublicRequest(req.url)
        ) {
          // Clear any stored authentication data
          localStorage.clear();
          
          // Redirect to login page
          this.router.navigate(['/login']);
        }
        
        return throwError(() => error);
      })
    );
  }

  private isPublicRequest(url: string): boolean {
    return this.publicPathFragments.some((fragment) => url.includes(fragment));
  }

  private asRmaPayload(value: unknown): RmaApiErrorPayload | null {
    if (!value || typeof value !== 'object') {
      return null;
    }

    return value as RmaApiErrorPayload;
  }
}
